import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { WorkersListComponent } from './workers-list/workers-list.component';
import { WorkersDetailComponent } from './workers-detail/workers-detail.component';
import { WorkersRoutingModule } from './workers-routing.module';
import { WorkersCapabiliyComponent } from './workers-capabiliy/workers-capabiliy.component';
import { WorkersZoneComponent } from './workers-zone/workers-zone.component';
import { WorkersTimeRangeComponent } from './workers-time-range/workers-time-range.component';
import { CoreModule } from 'src/app/core/core.module';
import { RatingModule } from 'primeng/rating';
import { WorkersVehicleComponent } from './workers-vehicle/workers-vehicle.component';
import { WorkersEquipmentsComponent } from './workers-equipments/workers-equipments.component';
import { VehiclesModule } from '../vehicles/vehicles.module';
import { WorkersVehiclesDetailComponent } from './workers-vehicles-detail/workers-vehicles-detail.component';
import { PasswordModule } from 'primeng/password';
import { WorkersFileComponent } from './workers-file/workers-file.component';
import { FileUploadModule } from 'primeng/fileupload';
import { AddSubworkerComponent } from './workers-detail/add-subworker/add-subworker.component';
import { WorkersBillableItemsComponent } from './workers-billable-items/workers-billable-items.component';
import { WorkersCalendarsEventsModalComponent } from './workers-detail/calendars-events-modal/workers-calendars-events-modal.component';
import { WorkerRateComponent } from './workers-detail/worker-rate/worker-rate.component';
import { TooltipModule } from 'primeng/tooltip';
import { WorkersGuardShiftComponent } from './workers-guard-shift/workers-guard-shift.component';
import { WorkersSeizureComponent } from './workers-seizure/workers-seizure.component';
import { WorkersSeizureAmmountComponent } from './workers-seizure/workers-seizure-ammount/workers-seizure-ammount.component';
import { WorkersCalendarsEventsDetailsModalComponent } from './workers-detail/calendars-events-details-modal/workers-calendars-events-details-modal.component';
import { WorkerContractComponent } from './workers-detail/worker-contract/worker-contract.component';

 
@NgModule({ declarations: [
        WorkersListComponent,
        WorkersDetailComponent,
        WorkersCapabiliyComponent,
        WorkersZoneComponent,
        WorkersVehicleComponent,
        WorkersTimeRangeComponent,
        WorkersGuardShiftComponent,
        WorkersCalendarsEventsModalComponent,
        WorkersCalendarsEventsDetailsModalComponent,
        WorkersEquipmentsComponent,
        WorkersVehiclesDetailComponent,
        WorkersFileComponent,
        WorkersBillableItemsComponent,
        AddSubworkerComponent,
        WorkerRateComponent,
        WorkersSeizureComponent,
        WorkersSeizureAmmountComponent,
        WorkerContractComponent
    ], imports: [WorkersRoutingModule,
        MessagesModule,
        CoreModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        RatingModule,
        VehiclesModule,
        PasswordModule,
        FileUploadModule,
        TooltipModule,
        TagModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class WorkersModule { }